export enum TicketNegotiationStatus {
  NotStarted = 'not_started',
  InProgress = 'in_progress',
  Accepted = 'accepted',
  NewDocVersion = 'new_doc_version',
  Failed = 'failed',
  Retracted = 'retracted',
}
